/* index.tsx generated by @compiled/babel-plugin v0.37.1 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2lx21bp4%7Bflex-direction%3Acolumn%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1e0c1txw%7Bdisplay%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4t3i1osq%7Bheight%3A100%25%7D");
import React, { useEffect, useRef } from 'react';
import type AnalyticsWebClient from '@atlassiansox/analytics-web-client';
import { cx } from '@atlaskit/css';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box } from '@atlaskit/primitives/compiled';
import type { AnalyticsAttributes } from '@atlassian/analytics-bridge';
import { PanelBody } from '@atlassian/panel-system';
import { PreviewPanelSniffer } from './preview-panel-sniffer';
const panelSystemStyles = {
  fillParent: "_4t3i1osq _1e0c1txw _2lx21bp4"
};
interface PreviewPanelBodyProps {
  analyticsAttributes?: AnalyticsAttributes;
  analyticsClient?: AnalyticsWebClient | undefined | null;
  children: React.ReactNode;
  panelType?: string;
  parentProduct?: string;
  styles?: Record<string, any>;
}
export const PreviewPanelBody = ({
  children,
  analyticsClient,
  parentProduct,
  panelType,
  analyticsAttributes,
  styles: consumerStyles
}: PreviewPanelBodyProps): React.JSX.Element => {
  const bodyRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    if (analyticsClient) {
      analyticsClient.sendTrackEvent({
        action: 'viewed',
        actionSubject: 'preview-panel',
        actionSubjectId: 'preview-panel-view',
        source: 'preview-panel',
        attributes: {
          parentProduct,
          panelType,
          ...(fg('add_capacity_tab_to_the_board_horizontal_nav') || fg('add-trigger-point-key-attribute-to-preview-panel') ? analyticsAttributes : {})
        }
      });
      // https://developer.atlassian.com/platform/analytics-pipeline/guides/deep-dive/cloud-mau/
      // Fires at most once per hour, per product.
      // Requires tenantInfo and userInfo to be set
      analyticsClient?.startUIViewedEvent();
    }
  }, [analyticsClient, parentProduct, panelType, analyticsAttributes]);

  // ignoring the rule as we have so many consumers of this that we need to be able to pass in styles
  /* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */
  const panelBodyContent = fg('ads-panel-system-gpp') ? <Box xcss={cx(panelSystemStyles.fillParent, !!consumerStyles && consumerStyles)} ref={bodyRef}>
			{children}
		</Box> : <Box xcss={cx(!!consumerStyles && consumerStyles)} ref={bodyRef}>
			{children}
		</Box>;
  /* eslint-enable @atlaskit/design-system/consistent-css-prop-usage */

  if (fg('ads-panel-system-gpp')) {
    const wrappedBody = <PanelBody spacing="none">{panelBodyContent}</PanelBody>;
    if (fg('platform_preview_panels_sniffer')) {
      return <PreviewPanelSniffer containerRef={bodyRef} analyticsClient={analyticsClient} parentProduct={parentProduct} panelType={panelType} analyticsAttributes={analyticsAttributes}>
					{wrappedBody}
				</PreviewPanelSniffer>;
    }
    return wrappedBody;
  }
  if (fg('platform_preview_panels_sniffer')) {
    return <PreviewPanelSniffer containerRef={bodyRef} analyticsClient={analyticsClient} parentProduct={parentProduct} panelType={panelType} analyticsAttributes={analyticsAttributes}>
				{panelBodyContent}
			</PreviewPanelSniffer>;
  }
  return panelBodyContent;
};